/** Package version of `@skaile/secrets`. */
export const VERSION = "0.0.0";

// Re-export interface + errors from plugins (convenience for consumers)
export type {
  ISecretsProvider,
  ListFilter,
  ProviderCapabilities,
  SecretMetadata,
  SetSecretOptions,
} from "@skaile/workspaces/plugins";
export {
  ProviderUnavailableError,
  SecretAccessDeniedError,
  SecretExpiredError,
  SecretNotFoundError,
  SecretsError,
} from "@skaile/workspaces/plugins";
export type { CredentialLifecycleConfig, RefreshResult } from "./lifecycle.js";
// Lifecycle
export { CredentialLifecycleService } from "./lifecycle.js";
export { EnvSecretsProvider } from "./providers/env.js";
export type { KeyStrategy } from "./providers/local.js";
// Built-in providers
export { LocalSecretsProvider } from "./providers/local.js";
export type { AuditSink, CredentialAccessed, RoutingRule, SecretsRouterConfig } from "./router.js";
// Router
export { SecretsRouter } from "./router.js";
